import { useId } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { clsx } from 'clsx';
import { Switch } from 'src/components/ui/switch';

// Shared by several integration forms, so it is generic over the form's values.
export const IncludeSubjectField = <T extends FieldValues>({
  control,
  name = 'include_subject_first_response' as Path<T>,
  className = '',
  disabled = false,
}: {
  control: Control<T>;
  name?: Path<T>;
  className?: string;
  disabled?: boolean;
}) => {
  const id = useId();

  return (
    <div className={clsx('content', className)}>
      <div>
        <div className="flex gap-2.5">
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Switch
                id={id}
                checked={value as boolean}
                onCheckedChange={onChange}
                disabled={disabled}
              />
            )}
          />
          <div className="flex flex-col gap-2.5">
            <label
              htmlFor={id}
              className="flex flex-row gap-1.5 items-center opacity-80 font-semibold text-sm text-ebony font-jamjuree"
            >
              <span>Include the email subject line in the context</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
